import SiteFooter from './SiteFooterContainer';

export default SiteFooter;
